import {RegistrationWizardAccountEntry, RegistrationWizardEntry} from "../types/RegistrationWizardEntry";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IRegistrationWizardEntryContent {
    title: string;
    description: string;
}

const ACCOUNT_DESCRIPTION = "Zakładamy dla Ciebie konto, aby pokazać ceny wszystkich mieszkań i rekomendować Ci najlepsze nieruchomości";

const PRICE_CONTENT: IRegistrationWizardEntryContent = {
    title: "Odkryj cenę mieszkania",
    description: ACCOUNT_DESCRIPTION
};

const SIGN_UP_CONTENT: IRegistrationWizardEntryContent = {
    title: "Załóż konto",
    description: ACCOUNT_DESCRIPTION
};

export const REGISTRATION_WIZARD_ENTRY_CONTENT: Record<RegistrationWizardEntry, IRegistrationWizardEntryContent> = {
    [UnlockChoiceEntryPoint.PRICE]: PRICE_CONTENT,
    [UnlockChoiceEntryPoint.LEAD]: PRICE_CONTENT,
    [UnlockChoiceEntryPoint.FLOOR_PLAN]: {
        title: "Pobierz rzut mieszkania",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.PRICE_HISTORY]: {
        title: "Odkryj historię cen",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.VENDOR_REPORT]: {
        title: "Odkryj raport o deweloperze",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS]: {
        title: "Zobacz zdjęcia z budowy",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.AREA_PHOTOS]: {
        title: "Zobacz zdjęcia okolicy",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.FAQ]: {
        title: "Zobacz odpowiedź na pytanie",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.SIGN_UP]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.FAVOURITE]: {
        title: "Dodaj ofertę do ulubionych",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.NOTIFICATIONS]: {
        title: "Otrzymuj powiadomienia o nowych ofertach",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.AI_ASSISTANT]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.ARTICLE_COMMENT]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.LEAD_INQUIRY]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.OFFER_PRICE]: {
        title: "Odkryj ceny na tym osiedlu",
        description: ACCOUNT_DESCRIPTION
    }
};

export const REGISTRATION_WIZARD_DEFAULT_CTA_LABEL = "Dalej";
import {RegistrationWizardAccountEntry, RegistrationWizardEntry} from "../types/RegistrationWizardEntry";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IRegistrationWizardEntryContent {
    title: string;
    description: string;
}

const ACCOUNT_DESCRIPTION = "Zakładamy dla Ciebie konto, aby pokazać ceny wszystkich mieszkań i rekomendować Ci najlepsze nieruchomości";

const PRICE_CONTENT: IRegistrationWizardEntryContent = {
    title: "Odkryj cenę mieszkania",
    description: ACCOUNT_DESCRIPTION
};

const SIGN_UP_CONTENT: IRegistrationWizardEntryContent = {
    title: "Załóż konto",
    description: ACCOUNT_DESCRIPTION
};

export const REGISTRATION_WIZARD_ENTRY_CONTENT: Record<RegistrationWizardEntry, IRegistrationWizardEntryContent> = {
    [UnlockChoiceEntryPoint.PRICE]: PRICE_CONTENT,
    [UnlockChoiceEntryPoint.LEAD]: PRICE_CONTENT,
    [UnlockChoiceEntryPoint.FLOOR_PLAN]: {
        title: "Pobierz rzut mieszkania",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.PRICE_HISTORY]: {
        title: "Odkryj historię cen",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.VENDOR_REPORT]: {
        title: "Odkryj raport o deweloperze",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS]: {
        title: "Zobacz zdjęcia z budowy",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.AREA_PHOTOS]: {
        title: "Zobacz zdjęcia okolicy",
        description: ACCOUNT_DESCRIPTION
    },
    [UnlockChoiceEntryPoint.FAQ]: {
        title: "Zobacz odpowiedź na pytanie",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.SIGN_UP]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.FAVOURITE]: {
        title: "Dodaj ofertę do ulubionych",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.NOTIFICATIONS]: {
        title: "Otrzymuj powiadomienia o nowych ofertach",
        description: ACCOUNT_DESCRIPTION
    },
    [RegistrationWizardAccountEntry.AI_ASSISTANT]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.ARTICLE_COMMENT]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.LEAD_INQUIRY]: SIGN_UP_CONTENT,
    [RegistrationWizardAccountEntry.OFFER_PRICE]: {
        title: "Odkryj ceny na tym osiedlu",
        description: ACCOUNT_DESCRIPTION
    }
};

export const REGISTRATION_WIZARD_DEFAULT_CTA_LABEL = "Dalej";
